import { Pipe, PipeTransform } from "@angular/core";
import { IOComponent } from "@comunicare/comunicare-interfaces";

@Pipe({ name: "hasValueArray" })
export class HasValueArrayPipe implements PipeTransform {
  transform(headerCompo: IOComponent, component: IOComponent[]): boolean {
    const compo = component?.find(
      (c) =>
        c.parentObservation?.code?.coding[0].code === headerCompo.parentObservation?.code?.coding[0].code &&
        c.code.coding[0].code === headerCompo.code.coding[0].code
    );
    return !!compo?.valueQuantity?.valueArray?.length;
  }
}
